var _mask, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLockCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_6778_958",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.487 12.3236C24.487 19.0854 19.0054 24.567 12.2435 24.567C5.48159 24.567 0 19.0854 0 12.3236C0 5.56167 5.48159 0.0800781 12.2435 0.0800781C19.0054 0.0800781 24.487 5.56167 24.487 12.3236Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.487 12.3236C24.487 19.0854 19.0054 24.567 12.2435 24.567C5.48159 24.567 0 19.0854 0 12.3236C0 5.56167 5.48159 0.0800781 12.2435 0.0800781C19.0054 0.0800781 24.487 5.56167 24.487 12.3236Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.487 12.3236C23.487 18.5332 18.4531 23.567 12.2435 23.567V25.567C19.5576 25.567 25.487 19.6377 25.487 12.3236H23.487ZM12.2435 23.567C6.03388 23.567 1 18.5332 1 12.3236H-1C-1 19.6377 4.92931 25.567 12.2435 25.567V23.567ZM1 12.3236C1 6.11395 6.03388 1.08008 12.2435 1.08008V-0.919922C4.92931 -0.919922 -1 5.00939 -1 12.3236H1ZM12.2435 1.08008C18.4531 1.08008 23.487 6.11395 23.487 12.3236H25.487C25.487 5.00939 19.5576 -0.919922 12.2435 -0.919922V1.08008Z",
    fill: "#D9D9D9",
    mask: "url(#path-1-inside-1_6778_958)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6778_958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.5H9.5C8.94772 11.5 8.5 11.9477 8.5 12.5V16C8.5 16.5523 8.94772 17 9.5 17H16.5C17.0523 17 17.5 16.5523 17.5 16V12.5C17.5 11.9477 17.0523 11.5 16.5 11.5Z",
    stroke: "black",
    strokeWidth: 1.02029,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.5V9.5C10.5 8.83696 10.7634 8.20107 11.2322 7.73223C11.7011 7.26339 12.337 7 13 7C13.663 7 14.2989 7.26339 14.7678 7.73223C15.2366 8.20107 15.5 8.83696 15.5 9.5V11.5",
    stroke: "black",
    strokeWidth: 1.02029,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6778_958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(7 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLockCircle);
export default __webpack_public_path__ + "static/media/icon-lock-circle.21340b0e9d4eb42a7755f4681602f238.svg";
export { ForwardRef as ReactComponent };